import styles from './styles/PartnersLinkPanelHomepage.css'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import Card from 'components/layout/Card'

const PartnersLinkPanelHomepage = () => {
  const history = useHistory()
  return (
    <div className={styles.container}>
      <div className={styles.partnersLearnMorePanel}>
        <Card level={0} className={classNames(styles.partnersHomepageCard, styles.pharmaBiotech)} onClick={() => { history.push('/partners/pharmaceuticals-and-biotech') }}>
          <img alt='pharma' className={styles.partnerIcon} src={`${CONFIG.assetsBaseURL}/images/homepage_partner_panel/pharma-homepage.svg`} />
          <span
            className={styles.learnMoreHeader}
          >
            Corporate, Pharma & Enterprise &#8594;
          </span>
          <span className={styles.partnersBlurb}>Stay on top of drug development & efficacy, clinical trials, and more</span>
        </Card>

        <Card level={0} className={classNames(styles.partnersHomepageCard, styles.uniLibrary)} onClick={() => { history.push('/partners/academic-institutions') }}>
          <img alt='university_library' className={styles.partnerIcon} src={`${CONFIG.assetsBaseURL}/images/homepage_partner_panel/uni-lib-homepage.svg`} />
          <span
            className={styles.learnMoreHeader}
          >
            Universities & Governments &#8594;
          </span>
          <span className={styles.partnersBlurb}>Track and improve research outcomes across your organization</span>
        </Card>

        <Card level={0} className={classNames(styles.partnersHomepageCard, styles.researchers)} onClick={() => { history.push('/partners/researchers') }}>
          <img alt='researcher' className={styles.partnerIcon} src={`${CONFIG.assetsBaseURL}/images/homepage_partner_panel/researcher.svg`} />
          <span
            className={styles.learnMoreHeader}
          >Researchers &#8594;
          </span>
          <span className={styles.partnersBlurb}>See exactly how publications have been cited by newer research</span>
        </Card>

        <Card level={0} className={classNames(styles.partnersHomepageCard, styles.publishers)} onClick={() => { history.push('/partners/publishers') }}>
          <img alt='publisher' className={styles.partnerIcon} src={`${CONFIG.assetsBaseURL}/images/homepage_partner_panel/publisher.svg`} />
          <span
            className={styles.learnMoreHeader}
          >Publishers &#8594;
          </span>
          <span className={styles.partnersBlurb}>Improve discoverability of your publications and support your authors</span>
        </Card>
      </div>
    </div>
  )
}

export default PartnersLinkPanelHomepage
